export default ['JsonRPCService', (JsonRPCService) => {
    return {
        getActivity: (activityPublicID) => {
            return JsonRPCService.send('pc', 'gateway/activity', 'getActivity', [activityPublicID]);
        },
        getActivitiesForUser: () => {
            return JsonRPCService.send('pc', 'gateway/activity', 'getActivitiesForUser', []);
        },
        getActivitiesForPolicy: (policyNumber) => {
            return JsonRPCService.send('pc', 'gateway/activity', 'getActivitiesForPolicy', [policyNumber]);
        },
        getActivitiesForAccount: (accountNumber) => {
            return JsonRPCService.send('pc', 'gateway/activity', 'getActivitiesForAccount', [accountNumber]);
        },
        getActivitiesForJob: (submissionNumber) => {
            return JsonRPCService.send('pc', 'gateway/activity', 'getActivitiesForJob', [submissionNumber]);
        },
        markActivityAsCompleted: (activityPublicID) => {
            return JsonRPCService.send('pc', 'gateway/activity', 'markActivityAsCompleted', [activityPublicID]);
        },
        getActivityNotes: (activityPublicId) => {
            return JsonRPCService.send('pc', 'gateway/activity', 'getNotesForActivity', [activityPublicId]);
        },
        createNoteForActivity: (activityPublicID, noteDTO) => {
            return JsonRPCService.send('pc', 'gateway/activity', 'createNoteForActivity', [activityPublicID, noteDTO]);
        },
        getActivityPatternsFor: (actPatternEntity) => {
            return JsonRPCService.send('pc', 'gateway/activity', 'getActivityPatternsFor', [actPatternEntity]);
        },
        createNewActivity: (activity, note) => {
            return JsonRPCService.send('pc', 'gateway/activity', 'createNewActivity', [activity, note]);
        },
        getAssignableUserForActivity: (actPatternEntity, id, activityPattern) => {
            return JsonRPCService.send('pc', 'gateway/activity', 'getAssignableUserForActivity', [actPatternEntity, id, activityPattern]);
        },
        reassignActivity: (selectedUser, id) => {
            return JsonRPCService.send('pc', 'gateway/activity', 'reassignActivity', [selectedUser, id]);
        },
        getActivitiesForCurrentUserAndGroups: () => {
            return JsonRPCService.send('pc', 'gateway/activity', 'getActivitiesForCurrentUserAndGroups', []);
        },
        getComplaintID: () => {
            return JsonRPCService.send('pc', 'gateway/activity', 'getComplaintID', []);
        }
    };
}];